export default __webpack_public_path__ + "static/airplan-41130b5e36c6c2449bad6bc1b28adac8.png";